<template>

  <section class="alert-container" :class="{ active: isActive }">
    <div class="wrap">
      <p>To install this web-app, tap the share icon below <img src="@/assets/ios-share.png"> and 'Add to Home Screen' <img src="@/assets/ios-home.png" class="home"> </p>
      <button class="button-close" @click="closePopup">x</button>
    </div>
  </section>

</template>

<script>
export default {
  name: 'Alert',
  inherit: true,
  data () {
    return {
      isActive: false
    }
  },
  mounted () {
    if (!this.$store.state.standalone && this.$store.state.iOS && this.$store.state.isSafari) {
      this.isActive = true
      setTimeout(() => {
        this.isActive = false
      }, 10000)
    }
  },
  methods: {
    closePopup () {
      this.isActive = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../scss/_variables.scss";

  .alert-container {
    position: fixed;
    bottom: 12px;
    left: 0;
    width: 100%;
    height: auto;
    display: none;

    text-align: center;
    background: rgba(white, 0.9);

    z-index: -1;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;

    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;

      width: 0;
      height: 0;
      margin: auto;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid rgba(white, 0.9);
    }

    .wrap {
      position: relative;
      margin: auto;
      padding: 20px;

      .button-close {
        position: absolute;
        top: -35px;
        left: 0;
        right: 0;
        width: 30px;
        height: 30px;
        margin: auto;
        color: black;
        background: rgba(white, 0.9);
        border-radius: 3px;
      }
    }

    p {
      margin-bottom: 5px;
      font-size: 14px;
      color: #333;

      img {
        display: inline-block;
        vertical-align: bottom;
        width: 20px;
        margin: 0 3px;
      }

      img.home {
        width: 24px;
      }
    }
  }

  .alert-container.active {
    display: block;
    z-index: 99999999;
    opacity: 1;
  }

</style>
